import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';

export interface GlossaryParameter  extends Parameter {

    searchTerm: number;
    orderBy: string;

}

export interface Glossary {
    id?: number;
    type:string;
    result:string;
    tenantId: any;
    branchId: any;

    parameters?: GlossaryParameter[];
    links?: any;

}

export const master = {
    GENERALPACKAGE: 'General Package',
    PAINLEVEL: 'Painlevel',
    SITE: 'Site',
    LEVELOFINJURY :'LevelofInjury',
    PERCENTAGEOFDISABILITY : 'PercentageofDisability',
    SURGERYPRIORITY:'priority',
    TREATMENTCLASSIFICATION:'TreatmentClassification',
    SUPPLIERMEDICINEREASON:'SupplierMedicineReason',
    SUPPLIERASSETREASON:'SupplierAssetReason',
    SUPPLIERITEMREASON:'SupplierItemReason',
    CAMPTYPE:'CAMP',

    DUATIONLEVEL:'duration',
    ADVICELEVEL:'advice',
    ROUTELEVEL:'route',
    AREALEVEL:'area',
    INSTRUCTIONSLEVEL:'instructions',
    ADJUVANTLEVEL:'adjuvant',
    TAKENLEVEL:'taken',

    MEDICINEADJUVANT:'Adjuvant',
    MEDICINEROUTE:'Route',
    MEDICINEAREA:'Area',
    MEDICINEINSTRUCTION:'Instruction',
    MEDICINEDURATION:'Duration',
    MEDICINEFREQUENCE:'Frequence',
    MEDICINEUNIT:'Unit',
    MEDICINEWHENTOAKEN:'WhenToTaken',
    MEDICINEADVICE:'Advice',
    MEDICINEDOSSAGE:'DosageLevel',
    PATINTAKEOUTPUT:'PATINTAKEOUTPUT',
    ITEMTYPE:"ITEM_TYPE",
    SERVICEDEPARTMENT:"PAYER_DEPARTMENT",
    FREQUENCT:"Frequency"
 };


export abstract class GlossaryData {

    abstract list(url: string): Observable<Glossary[]>;
    abstract create(url: string, data: Glossary): Observable<any>;
    abstract update(url: string, data: Glossary): Observable<any>;
    abstract delete(url: string): Observable<any>;
}
